import React, { useEffect, useState } from "react";
import Select from "react-select";
import { fetchJson } from "../../../lib/Fetching";

export default function Qualifier({ value, onChange }) {
  const [options, setOptions] = useState([]);

  const handleChange = options => onChange(options.map(o => o.value));

  const fetchData = () =>
    fetchJson("/sample_testing/api/qualifiers.json", {}).then(json => {
      const options = json.qualifiers.map(m => ({ label: m.text, value: m.id }));
      setOptions(options);
    });

  useEffect(() => {
    fetchData();
  }, []);

  if (options.length == 0) return null;

  const selectedValues = options.filter(o => value.includes(o.value));

  return (
    <Select
      value={selectedValues}
      placeholder={"Select qualifiers"}
      isMulti={true}
      autoload={true}
      id="qualifier_id"
      options={options}
      onChange={handleChange}
      isClearable={true}
    />
  );
}
